import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '../services/translate.service';
import {LABEL_SUFFIX} from '../translate.suffix';
import {Observable} from 'rxjs';

@Pipe({
  name: 'cpLabelTranslate',
  pure: true
})
export class LabelTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(query: string, args: any[] = []): Observable<string> {
    return this.translateService.transform(
      this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + LABEL_SUFFIX, ...args);
  }
}
